import React from 'react'
import { withIcon } from '../../withIcon'

function DownloadIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path fillRule="evenodd" clipRule="evenodd" d="M10 2.8125C10.2876 2.8125 10.5208 3.04569 10.5208 3.33333V12.0759L13.7984 8.79838C14.0018 8.59498 14.3316 8.59498 14.535 8.79838C14.7383 9.00178 14.7383 9.33155 14.535 9.53495L10.3683 13.7016C10.1649 13.905 9.83511 13.905 9.63171 13.7016L5.46505 9.53495C5.26165 9.33155 5.26165 9.00178 5.46505 8.79838C5.66845 8.59498 5.99822 8.59498 6.20162 8.79838L9.47917 12.0759V3.33333C9.47917 3.04569 9.71235 2.8125 10 2.8125ZM3.33333 13.6458C3.62098 13.6458 3.85417 13.879 3.85417 14.1667V15.8333C3.85417 16.1372 3.97489 16.4287 4.18977 16.6436C4.40466 16.8584 4.69611 16.9792 5 16.9792H15C15.3039 16.9792 15.5953 16.8584 15.8102 16.6436C16.0251 16.4287 16.1458 16.1372 16.1458 15.8333V14.1667C16.1458 13.879 16.379 13.6458 16.6667 13.6458C16.9543 13.6458 17.1875 13.879 17.1875 14.1667V15.8333C17.1875 16.4135 16.957 16.9699 16.5468 17.3801C16.1366 17.7904 15.5802 18.0208 15 18.0208H5C4.41984 18.0208 3.86344 17.7904 3.4532 17.3801C3.04297 16.9699 2.8125 16.4135 2.8125 15.8333V14.1667C2.8125 13.879 3.04569 13.6458 3.33333 13.6458Z" fill={color}/>
    </svg>
  )
}

export default withIcon(DownloadIcon)
